import { render, staticRenderFns } from "./DemoRulesModal.vue?vue&type=template&id=1220dc09"
import script from "./DemoRulesModal.vue?vue&type=script&lang=js"
export * from "./DemoRulesModal.vue?vue&type=script&lang=js"
import style0 from "./DemoRulesModal.vue?vue&type=style&index=0&id=1220dc09&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports